var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('equip-table',{attrs:{"title":"Own Power","title-heading":"h4","site-id":this.siteId,"site-data":_vm.siteData,"owner-id":this.ownerId,"show-qr-code":_vm.showQrCode,"filter-col":"category","filter-val":"Power"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }